var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.winner && _vm.winner.isComment)?_c('div',{staticClass:"messageButton",class:{ messageButtonOn: _vm.isMessageButtonOn }},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.open}},[_c('img',{staticClass:"image",attrs:{"src":"/img2022/bt_msg.png","srcset":"/img2022/bt_msg@2x.png" + " 2x","alt":"メッセージ・感想"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }